import React from 'react';
import { Select, Switch, Typography, Alert, Divider, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import AttributeListItem from './AttributeListItem';
import { useState } from 'react';
const { Text } = Typography;
const { Option } = Select;

const IssueCardAttribute = ({
  onClear,
  addNewAttribute,
  deleteExistingAttribute,
  onDetailedFieldsSelect,
  showDescription,
  descriptionToggle,
  fields,
  defaultAttributeValues,
  attributesAllignment,
  setAttributesAllignment,
}) => {
  const [newField, setNewField] = useState(null);
  const isStatusAlreadyExists =
    defaultAttributeValues &&
    defaultAttributeValues.find((el) => el.key === 'status');
  return (
    <>
      <div
        style={{
          display: 'flex',
          marginBottom: 16,
          alignItems: 'center',
          gap: '50px',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: 8 }}>
            <Text>Show Description</Text>
          </div>
          <Switch checked={showDescription} onChange={descriptionToggle} />
        </div>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <Text>Alignment:</Text>
          <Select
            onChange={(value) => setAttributesAllignment(value)}
            value={attributesAllignment}
            style={{ width: 240 }}
            options={[
              {
                value: 'horizontal',
                label: 'Horizontal',
              },
              {
                value: 'vertical',
                label: 'Vertical',
              },
            ]}
          />
        </div>
        <div></div>
      </div>
      <div>
        <Select
          style={{ width: 350 }}
          value={newField}
          onSelect={(value) => {
            setNewField(value);
          }}
          showSearch
          placeholder='Select Attribute'
        >
          {Object.values(fields)
            .filter((el) => !el.isUsed)
            .map((field) => {
              return (
                <Option key={field.key} value={field.name}>
                  {field.name}
                </Option>
              );
            })}
          {!isStatusAlreadyExists && (
            <Option key='status' value='status'>
              Status
            </Option>
          )}
        </Select>
        <Button
          disabled={!newField}
          style={{ marginLeft: 10 }}
          onClick={() => {
            addNewAttribute(newField);
            setNewField(null);
          }}
        >
          Add
        </Button>
      </div>

      <div>
        {defaultAttributeValues &&
          defaultAttributeValues.map((item, index) => (
            <AttributeListItem
              onDelete={deleteExistingAttribute}
              fields={fields}
              onClear={onClear}
              onDetailedFieldsSelect={onDetailedFieldsSelect}
              key={index}
              attribute={item}
              index={index}
              isStatusAlreadyExists={isStatusAlreadyExists}
            />
          ))}
      </div>
      <Divider />
      <div style={{ paddingBottom: '12px' }}>
        <Text type='secondary'>Note:</Text>
      </div>

      <div style={{ paddingBottom: '8px' }}>
        <Text type='secondary'>
          <InfoCircleOutlined /> If the value not found, `Not Available` will be
          shown
        </Text>
      </div>

      <div style={{ paddingBottom: '8px' }}>
        <Text type='secondary'>
          <InfoCircleOutlined /> Currently supported field schema types include
          String, Array, Number, Date and User
        </Text>
      </div>
    </>
  );
};
export default IssueCardAttribute;
